<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="联系我们" @navClick="navClick"></pageNav>
    <div class="main-content-area">
      <!-- 留言 -->
      <div class="message-area" ref="area0">
        <b-container fluid class="message-row">
          <b-row class="page-model-title-row">
            <b-col xl="5">
              <div class="page-model-title">
                <span>01.</span>
                <span>留言</span>
              </div>
            </b-col>
            <!-- pc -->
            <b-col xl="7" class="d-sm-none d-xl-block">
              <div class="message-btn-line flex align-end">
                <div class="message-btn" :class="{ 'message-btn-active': messageBtnIndex == 0 }" @click="changeMessageBtn(0)">信息留言</div>
                <div class="message-btn" :class="{ 'message-btn-active': messageBtnIndex == 1 }" @click="changeMessageBtn(1)">邮件留言</div>
              </div>
            </b-col>
            <!-- h5 -->
            <b-col xl="8" class="d-xl-none d-sm-block">
              <div class="sm-message-btn-line flex align-end">
                <div class="message-btn" :class="{ 'message-btn-active': messageBtnIndex == 0 }" @click="changeMessageBtn(0)">信息留言</div>
                <div class="message-btn" :class="{ 'message-btn-active': messageBtnIndex == 1 }" @click="changeMessageBtn(1)">邮件留言</div>
              </div>
            </b-col>
          </b-row>
          <b-row align-v="center" class="page-middle-content-row">
            <b-col sm="12" class="d-xl-none d-sm-block">
              <div class="bg-sm flex justify-center">
                <img src="../../assets/image/img2.png">
              </div>
            </b-col>
            <b-col xl="5" class="d-sm-none d-xl-block">
              <!-- <div class="img-box">
                <img src="../../assets/image/img3.png"/>
              </div> -->
            </b-col>
            <b-col xl="7" class="right-form">
              <el-form :model="form" label-width="0" class="message-form" ref="form" :rules="rule">
                <b-container fluid>
                  <b-row>
                    <b-col xl="6">
                      <el-form-item prop="name" :class="{'error-input':formValRes.name.show}">
                        <el-input v-model="form.name" :placeholder="!formValRes.name.show?'请输入姓名':''">
                          <template slot="suffix" v-if="formValRes.name.show">
                            <div class="flex align-center error-msg">
                              {{formValRes.name.msg}}
                            </div>
                          </template>
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" v-if="messageBtnIndex == 0"></b-col>
                    <b-col xl="6">
                      <el-form-item prop="contact" :class="{'error-input':formValRes.contact.show}">
                        <el-input v-model="form.contact" :placeholder="!formValRes.contact.show?'请输入联系电话':''">
                          <template slot="suffix" v-if="formValRes.contact.show">
                            <div class="flex align-center error-msg">
                              {{formValRes.contact.msg}}
                            </div>
                          </template>
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" v-if="messageBtnIndex == 0"></b-col>
                    <b-col xl="6" v-if="messageBtnIndex == 1">
                      <el-form-item prop="theme" :class="{'error-input':formValRes.theme.show}">
                        <el-input v-model="form.theme" :placeholder="!formValRes.theme.show?'邮件主题，不超过20个字':''">
                          <template slot="suffix" v-if="formValRes.theme.show">
                            <div class="flex align-center error-msg">
                              {{formValRes.theme.msg}}
                            </div>
                          </template>
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" v-if="messageBtnIndex == 1">
                      <el-form-item prop="mail" :class="{'error-input':formValRes.mail.show}">
                        <el-input v-model="form.mail" :placeholder="!formValRes.mail.show?'请输入您的电子邮箱':''">
                          <template slot="suffix" v-if="formValRes.mail.show">
                            <div class="flex align-center error-msg">
                              {{formValRes.mail.msg}}
                            </div>
                          </template>
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item prop="content" :class="{'error-input error-textarea':formValRes.content.show}">
                        <el-input v-model="form.content" type="textarea" :placeholder="formValRes.content.show?'请输入内容':'请输入内容，不超过200字'" :autosize="{ minRows: 8, maxRows: 8 }" resize="none" maxlength="200" />
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="3">
                      <div class="message-submit" @click="submitFeedBack">提交</div>
                    </b-col>
                  </b-row>
                </b-container>
              </el-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <!-- 联系方式 -->
      <!-- pc端 -->
      <div class="contact-area d-sm-none d-xl-block" ref="area1-xl">
        <div class="contact-box">
          <b-container fluid>
            <el-row class="page-model-title-row">
              <b-col xl="4">
                <div class="page-model-title">
                  <span>02.</span>
                  <span>联系方式</span>
                </div>
              </b-col>
            </el-row>
            <b-row class="page-middle-content-row">
              <b-col xl="12">
                <div class="contact-content flex align-center justify-center">
                  <div class="contact-info flex flex-column justify-around">
                    <div>
                      <span>地址:</span>
                      <span>{{concatInfo.company_address}}</span>
                    </div>
                    <div>
                      <span>邮编:</span>
                      <span>{{concatInfo.company_code}}</span>
                    </div>
                    <div>
                      <span>电话:</span>
                      <span>{{concatInfo.company_phone}}</span>
                    </div>
                    <div>
                      <span>邮箱:</span>
                      <span>{{concatInfo.company_email}}</span>
                    </div>
                  </div>
                  <div class="contact-map" id="mapArea">
                    <!-- 静态用的图片，实际换成高德地图 -->
                    <!-- <img src="../../assets/image/map.png"> -->
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- h5 -->
      <div class="contact-area sm-contact-area d-sm-block d-xl-none" ref="area1-sm">
        <div class="contact-box">
          <b-container fluid>
            <el-row class="page-model-title-row">
              <b-col xl="4">
                <div class="page-model-title">
                  <span>02.</span>
                  <span>联系方式</span>
                </div>
              </b-col>
            </el-row>
            <b-row class="page-middle-content-row">
              <b-col sm="12">
                <div class="contact-content sm-contact-content flex flex-column align-center">
                  <div class="contact-info flex">
                    <div class="contact-info-w100 flex flex-column">
                      <span>地址:</span>
                      <span>{{concatInfo.company_address}}</span>
                    </div>
                    <div class="contact-info-w50  flex flex-column">
                      <span>邮编:</span>
                      <span>{{concatInfo.company_code}}</span>
                    </div>
                    <div class="contact-info-w50 flex flex-column">
                      <span>电话:</span>
                      <span>{{concatInfo.company_phone}}</span>
                    </div>
                    <div class="contact-info-w50 flex flex-column">
                      <span>邮箱:</span>
                      <span>{{concatInfo.company_email}}</span>
                    </div>
                  </div>
                  <div class="contact-map" id="mapAreaH5">
                    <!-- 静态用的图片，实际换成高德地图 -->
                    <!-- <img src="../../assets/image/map.png"> -->
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      
      
    </div>
    <Footer @goScroll="goScroll"></Footer>
    <!-- 提示框 -->
    <el-dialog :visible.sync="visible" width="220px" :modal="false">
      <div class="no-error-area">
        <div class="error-icon flex align-center justify-center">
          <!-- <i class="el-icon-warning" /> -->
          <i :class="dialogMessage.icon=='success'?'el-icon-success':'el-icon-warning'" />
        </div>
        <div class="error-title">{{dialogMessage.message}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addFeedback, getContactUs } from "@/api/contactUs"
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  data() {
    return {
      navList: [{
        title: '  留言  '
      }, {
        title: '联系方式'
      }, ],
      currentActive: 0,
      messageBtnIndex: 0,
      form: {
        type: '信息留言'
      },
      trafficList: [],
      concatInfo: {},
      current: -1,
      map: null,
      topList: [],
      stopScroll: false,
      stopScrollTimeout: null,
      formValRes: {
        name: {
          show: false,
          msg: ''
        },
        contact: {
          show: false,
          msg: ''
        },
        theme: {
          show: false,
          msg: ''
        },
        mail: {
          show: false,
          msg: ''
        },
        content: {
          show: false,
          msg: ''
        }
      },
      visible: false,
      dialogMessage:{
        icon:'error',
        message:''
      },
      rule: {
        name: [{
          required: true, validator: (rule, value, callback) => {
            let temp = (value || '').trim()
            if (temp == '' || temp == null || temp == undefined) {
              this.formValRes.name.show = true
              this.formValRes.name.msg = '请输入姓名'
              callback(new Error(''))
            } else if (temp.length > 10) {
              this.formValRes.name.show = true
              this.formValRes.name.msg = '不能超过10个字符'
              callback(new Error(''))
            } else {
              this.formValRes.name.show = false
              callback()
            }
          }, trigger: ['change', 'blur']
        }],
        contact: [{
          required: true, validator: (rule, value, callback) => {
            let temp = (value || '').trim()
            if (temp == '' || temp == null || temp == undefined) {
              this.formValRes.contact.show = true
              this.formValRes.contact.msg = '请输入联系方式'
              callback(new Error(''))
            } else if (!/^1[34578]\d{9}$/.test(temp)) {
              this.formValRes.contact.show = true
              this.formValRes.contact.msg = '联系方式格式错误'
              callback(new Error(''))
            } else {
              this.formValRes.contact.show = false
              callback()
            }
          }, trigger: ['change', 'blur']
        }],
        theme: [{
          required: true, validator: (rule, value, callback) => {
            if (this.messageBtnIndex == 1) {
              let temp = (value || '').trim()
              if (temp == '' || temp == null || temp == undefined) {
                this.formValRes.theme.show = true
                this.formValRes.theme.msg = '请填写邮件主题'
                callback(new Error(''))
              } else if (this.form.theme.length > 20) {
                this.formValRes.theme.show = true
                this.formValRes.theme.msg = '不能超过20个字符'
                callback(new Error(''))
              } else {
                this.formValRes.theme.show = false
                callback()
              }
            } else[
              this.formValRes.theme.show = false
            ]
          }, trigger: ['change', 'blur']
        }],
        mail: [{
          required: true, validator: (rule, value, callback) => {
            if (this.messageBtnIndex == 1) {
              let temp = (value || '').trim()
              if (temp == '' || temp == null || temp == undefined) {
                this.formValRes.mail.show = true
                this.formValRes.mail.msg = '请填写邮箱'
                callback(new Error(''))
                // ^(\\w+((-\\w+)|(\\.\\w+))*)\\+\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$
                // ^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$ 
              } else if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(temp)) {
                this.formValRes.mail.show = true
                this.formValRes.mail.msg = '请填写正确的邮箱'
                callback(new Error(''))
              } else if (temp.length > 50) {
                this.formValRes.mail.show = true
                this.formValRes.mail.msg = '不能超过50个字符'
              } else {
                this.formValRes.mail.show = false
                callback()
              }
            } else[
              this.formValRes.mail.show = false
            ]
          }, trigger: ['change', 'blur']
        }],
        content: [{
          required: true, validator: (rule, value, callback) => {
            let temp = (value || '').trim()
            if (temp == '' || temp == null || temp == undefined) {
              this.formValRes.content.show = true
              this.formValRes.content.msg = "请输入反馈内容"
              callback(new Error(''))
            } else {
              this.formValRes.content.show = false
              callback()
            }
          }, trigger: ['change', 'blur']
        }]
      }
    }
  },
  mounted() {
    this.countViewCount()
    this.getContactUs()
  },
  destroyed() {
    if (this.map) {
      this.map?.destroy();
    }
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getContactUs() {
      getContactUs().then(res => {
        // console.log(res)
        if (res.code == 200) {
          let obj = res.data.find(v => v.name == '联系方式') || { list: [{}] }
          this.concatInfo = obj.list[0]
          // let posList = this.concatInfo.coordinate
          // if (!Array.isArray(posList)) {
          //   posList = [118.271, 26.5906]
          // }
          this.$nextTick(() => {
            const coordinate = (() => {
              try {
                // 查找 type=2，解析坐标
                const info = res.data?.find(i => i.type === '2')?.list?.[0];
                return info?.coordinate ? JSON.parse(info.coordinate) : [];
              } catch (e) {
                return []; // 异常返回空数组
              }
            })();
            this.initMap(coordinate)
          })
          // console.log()
          let obj2 = res.data.find(v => v.name == '交通指南') || { list: [] }
          this.trafficList = obj2.list
          this.$nextTick(() => {
            if (this.$route.query.to != undefined) {
              this.navClick({ index: Number(this.$route.query.to) })
              setTimeout(() => {
                window.addEventListener("scroll", this.handleScroll)
                window.addEventListener('resize', this.handleResize);
              }, 1000)
            } else {
              window.addEventListener('resize', this.handleResize);
              window.addEventListener("scroll", this.handleScroll)
            }
          })
        }
      })
    },
    handleResize(e) {
      let posList = this.concatInfo.coordinate
      if (!Array.isArray(posList)) {
        posList = [118.271, 26.5906]
      }
      this.$nextTick(() => {
        this.initMap(posList)
      })
    },
    navClick({ item, index }) {
      this.stopScroll = true
      if (this.stopScrollTimeout) clearTimeout(this.stopScrollTimeout)
      this.currentActive = index
      if (index == 1) {
        if (this.$refs[`area${index}-xl`].offsetTop != 0) {
          this.scrollByRef(`area${index}-xl`)
        } else {
          this.scrollByRef(`area${index}-sm`)
        }
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollByRef(`area${index}`)
          }, 100)
        })
      }
      this.$nextTick(() => {
        this.stopScrollTimeout = setTimeout(() => {
          this.stopScroll = false
        }, 1100)
      })
    },
    changeMessageBtn(index) {
      this.messageBtnIndex = index
      this.formValRes = {
        name: {
          show: false,
          msg: ''
        },
        contact: {
          show: false,
          msg: ''
        },
        theme: {
          show: false,
          msg: ''
        },
        mail: {
          show: false,
          msg: ''
        },
        content: {
          show: false,
          msg: ''
        }
      },
        this.$set(this.form, 'type', index == 1 ? '邮件留言' : '信息留言')
    },
    getBg(item) {
      return item.icon + ' trafic-icon'
    },
    // 提交反馈
    submitFeedBack() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          addFeedback({ ...this.form }).then(res => {
            // console.log(res)
            if (res.code == 200) {
              // this.$message.success('操作成功!')
              this.visible=true
              this.dialogMessage={
                icon:'success',
                message:'操作成功!'
              }
              this.form = {}
              this.changeMessageBtn(0)
              setTimeout(() => {
                this.formValRes = {
                  name: {
                    show: false,
                    msg: ''
                  },
                  contact: {
                    show: false,
                    msg: ''
                  },
                  theme: {
                    show: false,
                    msg: ''
                  },
                  mail: {
                    show: false,
                    msg: ''
                  },
                  content: {
                    show: false,
                    msg: ''
                  }
                }
              }, 10)
            }
          })
        } else {
          if (this.form.content && this.form.content.trim() == '') {
            this.$set(this.form, 'content', null)
          }
        }
      })
    },
    handleMouseEnter(index) {
      this.current = index
    },
    handleMouseLeave() {
      this.current = -1
    },
    goScroll(index) {
      this.navClick({ index: Number(index) })
    },
    initMap(positionList) {
      let temp = positionList.map(v => {
        return Number(v)
      })
      let idName = document.getElementById('mapArea').clientHeight > 0 ? 'mapArea' : 'mapAreaH5'
      AMapLoader.load({
        key: "f9b3654d4844fffb1911b78b87a3ef23", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map(idName, {
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 18, // 初始化地图级别
            center: temp, // 初始化地图中心点位置
            // zoomEnable: false,//禁止缩放
            // dragEnable: false,//禁止拖动
            // mapStyle: 'amap://styles/darkblue'
          });
          var marker = new AMap.Marker({
            position: new AMap.LngLat(temp[0], temp[1]),
            title: '福州奇点优创',
            color: '#000',
            label: {
              content: '福州奇点优创'
            },
          })
          this.map.add(marker)
        })
    },
    handleScroll(e) {
      if (this.stopScroll) {
        return
      }
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if (this.topList.length == 0) {
        for (let i = 0; i < 3; i++) {
          if (i == 1) {
            if (this.$refs[`area${i}-xl`].offsetTop != 0) {
              this.topList.push(this.$refs[`area${i}-xl`].offsetTop - 200)
            } else {
              this.topList.push(this.$refs[`area${i}-sm`].offsetTop - 200)
            }
          } else {
            this.topList.push(this.$refs[`area${i}`].offsetTop - 200)
          }
        }
      }
      let temp = this.currentActive
      let result = this.topList.reduce((res, curV, curVindex) => {
        if (nowTop >= curV) {
          res = curVindex
        }
        return res
      }, temp)
      // 获取距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 获取可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部                    
        result = this.topList.length - 1
      }
      this.currentActive = result
      // console.log(this.topList)
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.visible = false
        }, 1500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// 留言
.message-area {
  // height: 500px;
  // max-width: 1200px;
  min-height: 714px;
  margin: 0 auto;
  padding-top: 60px;
  position: relative;
  background-image: url("../../assets/image/bg32.png");
  // background-position:50% 80%;
  background-size: 1920px 714px;
  background-position: calc(50%) 0;
  .message-row{
    max-width:1200px;
    margin-left:auto;
    margin-right:auto;
  }
  .message-btn-line {
    height: 72px;
    padding-left: 15px;
    .message-btn {
      padding: 2px 30px;
      background: #ffffff;
      border: 2px solid #1566d4;
      cursor: pointer;
      user-select: none;
      font-family: "SourceHanSansCN-Regular";
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      margin-right: 15px;
    }

    .message-btn-active {
      color: #fff;
      background: #1566d4;
    }
  }

  .sm-message-btn-line {
    padding: 30px 00 10px 0px;
    border-bottom: 4px solid #3b7af4;
    margin-bottom: 20px;
    z-index: 10;
    position: relative;

    .message-btn {
      font-family: "SourceHanSansCN-Regular";
      font-size: 18px;
      color: #1566d4;
      width: 50%;
      text-align: center;
      user-select: none;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
    }

    .message-btn-active {
      color: #fff;
      background: #1566d4;
    }
  }

  .img-box {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .right-form {
    padding-left: 0;
  }

  .message-form {
    z-index: 10;
    position: relative;
    margin-top: 30px;

    .error-msg {
      color: red;
      line-height: 50px;
      padding-right: 10px;
      font-size: 16px;
      z-index: -1;
    }
    .error-input /deep/ .el-input__inner {
      border: 2px solid red !important;
      padding-right: 50% !important;
    }
    .error-input /deep/.el-textarea__inner {
      border: 2px solid red !important;
    }
    .error-textarea {
      ::v-deep .el-textarea__inner::placeholder {
        color: red;
        font-size: 16px;
        line-height: 50px;
      }
      /* 谷歌 */
      ::v-deep .el-textarea__inner::-webkit-input-placeholder {
        color: red;
        font-size: 16px;
        line-height: 50px;
      }
      /* 火狐 */
      ::v-deep .el-textarea__inner:-moz-placeholder {
        color: red;
        font-size: 16px;
        line-height: 50px;
      }
      /*ie*/
      ::v-deep .el-textarea__inner:-ms-input-placeholder {
        color: red;
        font-size: 16px;
        line-height: 50px;
      }
    }
    /deep/.el-form-item__error {
      opacity: 0;
    }
    /deep/.el-input__inner {
      background: rgba(255, 255, 255, 0.5);
      border: 2px solid #1566d4;
      height: 50px;
      line-height: 50px;
      border-radius: 0;
      font-size: 20px;
    }

    /deep/.el-textarea__inner {
      background: rgba(255, 255, 255, 0.5);
      border: 2px solid #1566d4;
      border-radius: 0;
    }
  }

  .message-submit {
    background: #1566d4;
    height: 46px;
    font-family: "SourceHanSansCN-Regular";
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }

  .bg-sm {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 80%;
      margin-top: -38%;
      z-index: -1;
    }
  }
}

// 联系方式
.contact-area {
  width: 100%;
  min-height: 642px;
  background-image: url("../../assets/image//bg5.png");
  background-size: cover;
  // margin: 60px 0 0 0;
  padding-bottom: 40px;

  .contact-box {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
  }

  .contact-content {
    padding-top: 40px;

    .contact-info {
      padding: 40px 20px;
      min-width: 440px;
      max-width: 286px;
      min-height: 286px;
      background: #1566d4;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      z-index: 20;

      div {
        margin-bottom: 8px;

        > span {
          font-family: "SourceHanSansCN-Regular";
          font-size: 20px;
        }

        > span:first-of-type {
          color: rgba(255, 255, 255, 0.4);
          margin-right: 5px;
        }

        > span:last-of-type {
          color: #ffffff;
        }
      }

      div:last-of-type {
        margin-bottom: 0;
      }
    }

    .contact-map {
      width: 779px;
      margin-left: -240px;
      height: 386px;

      img {
        width: 779px;
        height: 386px;
      }
    }
  }
}

.sm-contact-area {
  min-height: 700px;
  background-image: url("../../assets/image//bg4.png");

  .contact-map {
    margin-top: -80px;
    width: 100% !important;
    max-width: 702px !important;
    height: 360px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .contact-info {
    width: 574px !important;
    max-width: 574px !important;
    min-height: 326px !important;
    flex-wrap: wrap;
    div {
      > span {
        font-size: 28px !important;
        word-break: break-all;
      }
    }
    .contact-info-w100 {
      width: 100%;
    }

    .contact-info-w50 {
      width: 50%;
    }
  }
}

// 交通
.traffic-area {
  width: 100%;
  min-height: 465px;
  background-image: url("../../assets/image//bg3.png");
  background-size: cover;
  padding-top: 60px;

  .traffic-box {
    max-width: 1200px;
    margin: 0 auto;
  }

  .page-model-title {
    margin-bottom: 30px;
  }

  .traffic-item {
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
    border: 2px solid #1566d4;
    backdrop-filter: blur(1px);
    user-select: none;
    padding: 40px 10px;
    margin-bottom: 20px;

    .trafic-icon {
      width: 66px;
      height: 66px;
      background-size: cover;
      margin: 20px auto 30px auto;
    }
    .traffice-image {
      width: 66px;
      height: 66px;
      background-size: cover;
      margin: 20px auto 30px auto;
      overflow: hidden;
      img {
        height: 66px;
        width: 66px;
      }
    }

    // .ticon {
    //   background-image: url("../../assets/image/ticon-s.png");
    // }

    // .ticon2 {
    //   background-image: url("../../assets/image/ticon2-s.png");
    // }

    // .ticon3 {
    //   background-image: url("../../assets/image/ticon3-s.png");
    // }

    // .ticon4 {
    //   background-image: url("../../assets/image/ticon4-s.png");
    // }

    .traffic-title {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 18px;
      color: #1566d4;
      text-align: center;
    }

    .traffic-content {
      font-family: "SourceHanSansCN-Regular";
      font-size: 15px;
      color: #333333;
      line-height: 21px;
      text-align: center;
      min-height: 67px;
      user-select: none;
      margin-top: 20px;
    }
  }

  .traffic-item:hover {
    background: #1566d4;

    // .ticon {
    //   background-image: url("../../assets/image/ticon.png");
    // }

    // .ticon2 {
    //   background-image: url("../../assets/image/ticon2.png");
    // }

    // .ticon3 {
    //   background-image: url("../../assets/image/ticon3.png");
    // }

    // .ticon4 {
    //   background-image: url("../../assets/image/ticon4.png");
    // }

    .traffic-title {
      color: #fff;
    }

    .traffic-content {
      color: #fff;
    }
  }
}
/deep/ .amap-logo {
  display: none !important;
  opacity: 0 !important;
}
/deep/ .amap-copyright {
  opacity: 0 !important;
}

/deep/.el-dialog {
  background-color: #606266;
  border-radius: 20px;
  opacity: 0.7;

  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/deep/.el-dialog__body {
  padding-top: 20px;
  padding-bottom: 20px;
}
/deep/.el-dialog__header {
  padding: 0;
}
.no-error-area {
  .error-icon {
    width: 100%;
    min-height: 70px;
    i {
      color: #fff;
      width: 48px;
      height: 48px;
      font-size: 56px;
    }
  }
  .error-title {
    color: #fff;
    font-size: 20px;
    text-align: center;
    margin-top: 10px;
  }
}

// 移动端
@media (min-width: 576px) and (max-width: 1200px) {
  //留言
  .message-area {
    background-image: none;
    margin-bottom: 60px;
    .sm-message-btn-line {
      .message-btn {
        font-size: 32px;
        // padding-top:10px ;
        // padding-bottom:10px ;
        line-height: 64px;
        height: 64px;
      }
    }
    .message-form {
      .error-msg {
        color: red;
        line-height: 88px;
        padding-right: 20px;
        font-size: 28px;
      }
      /deep/.el-input__inner {
        background: rgba(255, 255, 255, 0.5);
        border: 2px solid #1566d4;
        height: 88px;
        line-height: 88px;
        border-radius: 0;
        font-size: 28px;
      }

      /deep/.el-textarea__inner {
        background: rgba(255, 255, 255, 0.5);
        border: 2px solid #1566d4;
        border-radius: 0;
        font-size: 28px;
        height: 416px !important;
      }
    }
    .message-submit {
      font-size: 40px;
      height: 88px;
      line-height: 88px;
    }
  }

  // 联系方式
  .sm-contact-area {
    .contact-map {
      width: 100% !important;
      max-width: 702px !important;
      height: 360px !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }

  // 交通方式
  .traffic-area {
    .traffice-image {
      width: 176px !important;
      height: 176px !important;
      img {
        height: 176px !important;
        width: 176px !important;
      }
    }
    .traffic-title {
      font-size: 24px !important;
    }
    .traffic-content {
      font-size: 20px !important;
      padding: 0 50px;
    }
  }
  /deep/.el-dialog {
    width: 350px !important;
  }
  .no-error-area {
    .error-icon {
      min-height: 120px;
      i {
        width: 80px;
        font-size: 80px !important;
      }
    }
    .error-title {
      font-size: 36px;
    }
  }
}
</style>